export class UserActivation {
    userId:string;  
    requestedOn:Date; 
    userAgent:string;
    ipAddress:string;
    securityCode:string;
    expiryDate:Date;
    isActive:boolean;
    facilityId:number;
    activationId : string;
    password:string;
    clientkey:string;
    clientsalt:string;
}